import { DependencyList, useEffect } from "react";
import { useLatestRef } from "@design-system/hooks/useLatestRef";
import { useMemoByKeys } from "./useMemoByKeys";

export const useDebouncedEffect = (
    effect: () => void,
    deps: DependencyList = [],
    delay: number,
) => {
    const effectRef = useLatestRef(effect);
    const runEffect = useMemoByKeys(() => () => effectRef.current(), deps);

    useEffect(() => {
        const handler = setTimeout(runEffect, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [runEffect, delay]);
};
